"use client"

import { useEffect } from "react"

/**
 * Stamps `html[data-hydrated="true"]` once React owns the page.
 *
 * E2E specs gate CTA clicks on it: handlers are inert until hydration
 * commits, so clicking earlier can silently no-op. Renders null — same
 * shape as `dark-shell-sync.tsx`, mounted next to it in
 * `[country]/[locale]/layout.tsx`.
 */
export function HydrationMarker() {
  useEffect(() => {
    document.documentElement.dataset.hydrated = "true"
  }, [])
  return null
}
